import { useEffect } from "react";
import { Toaster, toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { IAppState } from "../../store/app-state";
import { setServerError, setServerResponse } from "store/application/application-action";
import { ReactComponent as CheckIcon } from "components/icons/checkIcon.svg";

const ResponseMessage = () => {
  const { serverError, serverResponse } = useSelector((state: IAppState) => state.application);
  const dispatch = useDispatch();

  const styles = {
    borderRadius: "12px",
    backgroundColor: "rgba(15, 15, 55, 0.7)",
    color: "white"
  };

  useEffect(() => {
    const TIMER = 5000000;
    if (serverResponse) {
      toast.success(serverResponse, {
        style: styles,
        icon: <CheckIcon width={20} height={20} />
      });
    }
    if (serverError) {
      toast.error(serverError ? serverError.message : "Server Error.", {
        style: styles
      });
    }

    const timer = setTimeout(() => {
      dispatch(setServerResponse(null));
      dispatch(setServerError(null));
    }, TIMER);

    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [serverError, serverResponse, dispatch]);

  return (
    <Toaster
      position="bottom-center"
      reverseOrder={true}
      toastOptions={{
        className: "toastItem",
      }}
    />
  );
};

export default ResponseMessage;
